import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import {language} from './language/vn';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home/main',
    pathMatch: 'full',
  },
  {
    path: 'chucnangchung',
    redirectTo: 'chucnangchung/lichcongtac',
    pathMatch: 'full',
  },
  {
    path: 'danhmuc',
    redirectTo: 'danhmuc/chucvu',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    redirectTo: 'admin/danhmucsovanthu',
    pathMatch: 'full',
  },
  {
    path: 'hosocongviec',
    redirectTo: 'hosocongviec/hosocanhan',
    pathMatch: 'full',
  },
  {
    path: 'tainguyen',
    redirectTo: 'tainguyen/vanbanphapquy',
    pathMatch: 'full',
  },
  {
    path: 'datxe',
    redirectTo: 'datxe/xemketquaduyet',
    pathMatch: 'full',
  },
  {
    path: 'dangkylich',
    redirectTo: 'dangkylich/xemketqualichphong',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: language.home
    },
    children: [
      {
        path: 'base',
        loadChildren: () => import('./views/base/base.module').then(m => m.BaseModule)
      },
      {
        path: 'buttons',
        loadChildren: () => import('./views/buttons/buttons.module').then(m => m.ButtonsModule)
      },
      {
        path: 'charts',
        loadChildren: () => import('./views/chartjs/chartjs.module').then(m => m.ChartJSModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule)
      },
      {
        path: 'theme',
        loadChildren: () => import('./views/theme/theme.module').then(m => m.ThemeModule)
      },
      {
        path: 'widgets',
        loadChildren: () => import('./views/widgets/widgets.module').then(m => m.WidgetsModule)
      },
      {
        path: 'danhmuc',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'chucnangchung',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'hosocongviec',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'tainguyen',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'giaiquyetsuvu',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'vanbanden',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'vanbandi',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'tintuc',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'datxe',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'dangkylich',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'home',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      },
      {
        path: 'user',
        loadChildren: () => import('./views/egov/egov.module').then(m => m.EgovModule)
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
